<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";


// const showMenu = ref(false);
const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

const minimizeSidebar = () => store.commit("sidebarMinimize");
// const toggleConfigurator = () => store.commit("toggleConfigurator");

// const closeMenu = () => {
//   setTimeout(() => {
//     showMenu.value = false;
//   }, 100);
// };

// function timeAgo(dateString) {
//   const now = new Date();
//   const date = new Date(dateString);
//   const seconds = Math.floor((now - date) / 1000);

//   if (seconds < 60) return `${seconds} sec ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hr${hours > 1 ? 's' : ''} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days > 1 ? 's' : ''} ago`;
// }

// const notifications = ref([]);
// const getNotifications = async () => {
//   axios.post("api/getNotifications").then((response) => {
//     notifications.value = response.data;
//     console.log(response.data);
//   }).catch((error) => {
//     console.error("Error fetching notifications:", error);
//   });
// };
// onMounted(() => {
//   getNotifications();
// });
</script>
<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0  shadow-none border-radius-xl custom-navbar mx-0"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''" v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar">
        <!-- <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" :placeholder="isRTL ? 'أكتب هنا...' : 'Type here...'" />
          </div>
        </div> -->
        <ul class="navbar-nav justify-content-end pe-md-3">
          <!-- <li class="nav-item d-flex align-items-center">
            <div class="dropdown">
              <a href="#" class="nav-link dropdown-toggle text-white font-weight-bold" role="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa fa-user me-sm-2"></i>
                <span class="d-sm-inline d-none">Login</span>
              </a>

              <ul class="dropdown-menu ctm-dropdown dropdown-menu-end">
                <li>
                  <button class="dropdown-item" @click="logout">Logout</button>
                </li>
              </ul>
            </div>

          </li> -->
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="minimizeSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
          <!-- <li class="px-2 nav-item d-flex align-items-center">
            <a class="p-0 nav-link text-white" href="/setting">
              <i class="cursor-pointer fa fa-cog fixed-plugin-button-nav"></i>
            </a>
          </li>
          <li class="nav-item dropdown d-flex align-items-center" :class="isRTL ? 'ps-2' : 'pe-2'">
            <a href="#" class="p-0 nav-link text-white" :class="[showMenu ? 'show' : '']" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu" @blur="closeMenu">
              <i class="cursor-pointer fa fa-bell"></i>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton">
              <li class="mb-2" v-for="(item, index) in notifications" :key="index">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        {{ item.data.message }}
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        {{  timeAgo(item.created_at) }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li> -->
        </ul>
      </div> 
    </div>
  </nav>
</template>
